// extracted by mini-css-extract-plugin
module.exports = {"ContactIcon":"_2cdxu2lhEqxifU7eY9GMnr","Wrapper":"fnFLO7HjNAqkL6Iy73CnZ","Count":"aJr4LZH_4jUHJDVXD_7d-"};